import { SEASON } from "../config"

export const About = (props) => {
  const paragraph = props.data
    ? props.data[`paragraph_${SEASON}`]
    : "loading..."

  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {SEASON === 'summer' ? (
              <img
                src="img/climb.jpg"
                alt="Скалодром"
                className="img-responsive"
                style={{ width: '100%', borderRadius: '8px' }}
              />
            ) : (
              <div className="embed-responsive embed-responsive-16by9">
                <video className="embed-responsive-item" width="560" height="315" controls autoPlay muted>
                  <source src={`https://yes35.ru/images/glk.video.mp4`} type="video/mp4" />
                  Ваш браузер не поддерживает видео.
                </video>
              </div>
            )}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>О проекте</h2>
              <p>{paragraph}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
